
/* eslint-disable max-len */

import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Swiper, { Keyboard, Lazy, Virtual } from 'swiper';
import { Attachment } from '@/types';
import AttachmentDetails from '@/components/AttachmentDetails.vue';

Swiper.use([Keyboard, Lazy, Virtual]);
// Swiper.use([Keyboard]);

@Component({
  components: {
    AttachmentDetails,
  },
})
export default class AttachmentsGallery extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  // Lista degli allegati da visualizzare nello Swiper
  @Prop({ type: Array, default: () => [] }) readonly attachments!: Attachment[]
  // Allegato da visualizzare nello Swiper
  @Prop({ type: Object, default: null }) readonly attachment!: Attachment | null
  // Titolo del dialog
  @Prop({ type: String, default: 'Allegati' }) readonly title!: string
  // Lista degli allegati selezionati
  @Prop({ type: Array, default: () => [] }) readonly selectedAttachments!: Attachment[]

  dialog = false

  swiper: Swiper | null = null

  swiperAttachments: Attachment[] = []

  fullscreen = false

  get isSelected(): boolean {
    if (this.currentAttachment) {
      return this.selectedAttachments.includes(this.currentAttachment);
    }
    return false;
  }
  set isSelected(val: boolean) {
    if (this.currentAttachment) {
      this.$emit('select', this.currentAttachment, val);
    }
  }

  isImage(attachment: Attachment) {
    return attachment.mimetype.startsWith('image/');
  }

  isVideo(attachment: Attachment) {
    return attachment.mimetype.startsWith('video/');
  }

  isAudio(attachment: Attachment) {
    return attachment.mimetype.startsWith('audio/');
  }

  isPDF(attachment: Attachment) {
    return attachment.mimetype.startsWith('application/pdf');
  }

  get currentAttachmentIndex(): number {
    if (this.swiper) {
      return this.swiper.activeIndex;
    }
    return 0;
  }

  // Ritorna l'allegato attualmente mostrato nello Swiper
  get currentAttachment(): Attachment | null {
    if (this.swiper) {
      return this.attachments[this.swiper.activeIndex];
    }
    return null;
  }

  get attachmentsCount(): number {
    return this.swiperAttachments.length;
  }

  get selectedAttachmentsCount(): number {
    return this.selectedAttachments.length;
  }

  get isPrevDisabled(): boolean {
    if (this.attachments.length === 1) {
      return true;
    }

    return this.swiper?.isBeginning === true;
  }

  get isNextDisabled(): boolean {
    if (this.attachments.length === 1) {
      return true;
    }

    return this.swiper?.isEnd === true;
  }

  get hasDownloadListener(): boolean {
    return this.$listeners && typeof this.$listeners.download === 'function';
  }

  get hasDeleteListener(): boolean {
    return this.$listeners && typeof this.$listeners.delete === 'function';
  }

  get hasSelectListener(): boolean {
    return this.$listeners && typeof this.$listeners.select === 'function';
  }

  @Watch('attachments')
  onAttachmentsChange(val: Attachment[]) {
    console.log(`${this.constructor.name}: onAttachmentsChange()`); // eslint-disable-line no-console

    // La lista degli allegati è cambiata

    // Se la lista degli allegati è vuota chiude il dialog e non fa altro
    if (val.length === 0) {
      this.dialog = false;
      return;
    }

    // Aggiungo la lista degli allegati visualizzati nello Swiper
    this.swiperAttachments = val;

    // Se la lista degli allegati non è vuota,
    // aggiorna lo Swiper e fa puntare lo Swiper ad un allegato esistente
    if (val.length > 0) {
      if (this.swiper && typeof this.swiper.update === 'function') {
        console.log(`${this.constructor.name}: onAttachmentsChange() this.swiper.update()`); // eslint-disable-line no-console

        this.$nextTick(() => {
          if (this.swiper && typeof this.swiper.update === 'function') {
            this.swiper.update();
          }
        });
      }
    }
  }

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange()`); // eslint-disable-line no-console

    if (val === true) {
      // Dialog aperto

      // Aggiungo la lista degli allegati visualizzati nello Swiper
      this.swiperAttachments = this.attachments;

      this.$nextTick(() => {
        if (this.swiper && typeof this.swiper.update === 'function' && this.swiper.destroyed === false) {
          console.log(`${this.constructor.name}: onValueChange() this.swiper.update()`); // eslint-disable-line no-console

          this.swiper.update();
        } else {
          console.log(`${this.constructor.name}: onValueChange() this.swiper = new Swiper()`); // eslint-disable-line no-console

          this.swiper = new Swiper('.swiper', {
            loop: false,

            centeredSlides: true,
            slidesPerView: 1,
            setWrapperSize: true,
            // width: 800,

            virtual: {
              enabled: true,
              cache: false,
              slides: this.swiperAttachments,
              addSlidesAfter: 100,
              addSlidesBefore: 100,
              renderSlide: (attachment: Attachment, index: number) => {
                console.log(`${this.constructor.name}: renderSlide() index =`, index); // eslint-disable-line no-console

                if (this.isImage(attachment)) {
                  return `
                    <div class="swiper-slide" style="text-align: center; font-size: 18px; background: #fff; display: flex; justify-content: center; align-items: center;">
                      <img src="/attachment/${attachment.filename}" loading="lazy"
                        style="width: auto; height: auto; max-width: 100%; max-height: 100%;" />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  `;
                  // return `
                  //   <div class="swiper-slide" style="text-align: center; font-size: 18px; background: #fff; display: flex; justify-content: center; align-items: center;">
                  //     <img src="/attachment/${attachment.filename}" loading="lazy"
                  //       style="width: auto; height: auto; max-width: 100%; max-height: 100%; -ms-transform: translate(-50%, -50%); -webkit-transform: translate(-50%, -50%); -moz-transform: translate(-50%, -50%); transform: translate(-50%, -50%); position: absolute; left: 50%; top: 50%;" />
                  //     <div class="swiper-lazy-preloader"></div>
                  //   </div>
                  // `;
                }

                if (this.isVideo(attachment)) {
                  return `
                    <div class="swiper-slide" style="text-align: center; font-size: 18px; background: #fff; display: flex; justify-content: center; align-items: center;">
                      <video controls="controls" style="width: 100%; height: auto;">
                        <source src="/attachment/${attachment.filename}" type="${attachment.mimetype}"></source>
                      </video>
                    </div>
                  `;
                }

                // if (this.isAudio(attachment)) {
                //   return `
                //     <div class="swiper-slide">
                //       <audio controls data-src="${attachment.filename}"></audio>
                //       <div class="swiper-lazy-preloader"></div>
                //     </div>
                //   `;
                // }

                if (this.isPDF(attachment)) {
                  return `
                    <div class="swiper-slide"
                      style="text-align: center; font-size: 18px; background: #fff; display: flex; justify-content: center; align-items: center;">
                      <iframe src="/attachment/${attachment.filename}"
                        width="100%" height="100%" style="border: none;"></iframe>
                    </div>
                  `;
                }

                return `
                  <div class="swiper-slide">
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; width: 100%;">
                      <span class="mdi mdi-eye-off-outline" style=" font-size: 4rem;"></span>
                      <span class="mt-4" style="font-size: 1.1rem;">Anteprima non disponibile</span>
                    </div>
                  </div>
                `;
              },
            },

            // autoHeight: true,

            grabCursor: true,

            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },

            // pagination: {
            //   el: '.swiper-pagination',
            //   type: 'fraction',
            // },

            // navigation: {
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev',
            // },
            // scrollbar: {
            //   el: '.swiper-scrollbar',
            // },
          });
        }

        // Se è stato passato un specifico allegato da visualizzare, lo visualizza
        if (this.attachment) {
          const index = this.attachments.findIndex((a) => a.id === this.attachment?.id);
          console.log(`${this.constructor.name}: onValueChange() index =`, index); // eslint-disable-line no-console

          if (index >= 0) {
            if (this.swiper && typeof this.swiper.slideTo === 'function') {
              console.log(`${this.constructor.name}: onValueChange() this.swiper.slideTo()`); // eslint-disable-line no-console
              this.swiper.slideTo(index);
            }
          }
        }
      });
    } else {
      // Dialog chiuso

      // Distruggo lo Swiper
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        console.log(`${this.constructor.name}: onValueChange() this.swiper.destroy()`); // eslint-disable-line no-console
        this.swiper.destroy();
      }

      // Azzero sempre lo Swiper
      this.swiper = null;

      // Rimuovo la lista degli allegati visualizzati nello Swiper
      this.swiperAttachments = [];
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    console.log(`${this.constructor.name}: onDialogChange()`); // eslint-disable-line no-console

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get isFullscreen() {
    return this.$fullscreen.isFullscreen;
  }

  async onFullscreen() {
    await this.$fullscreen.request();
    this.fullscreen = true;

    // Aggiorna lo Swiper
    this.$nextTick(() => {
      if (this.swiper && typeof this.swiper.update === 'function' && this.swiper.destroyed === false) {
        console.log(`${this.constructor.name}: onFullscreen() this.swiper.update()`); // eslint-disable-line no-console

        this.swiper.update();
      }
    });
  }

  async onFullscreenExit() {
    await this.$fullscreen.exit();
    this.fullscreen = false;

    // Aggiorna lo Swiper
    this.$nextTick(() => {
      if (this.swiper && typeof this.swiper.update === 'function' && this.swiper.destroyed === false) {
        console.log(`${this.constructor.name}: onFullscreen() this.swiper.update()`); // eslint-disable-line no-console

        this.swiper.update();
      }
    });
  }

  onPrev() {
    console.log(`${this.constructor.name}: onPrev()`); // eslint-disable-line no-console

    if (this.swiper && typeof this.swiper.slidePrev === 'function') {
      this.swiper.slidePrev();
    }
  }

  onNext() {
    console.log(`${this.constructor.name}: onNext()`); // eslint-disable-line no-console

    if (this.swiper && typeof this.swiper.slideNext === 'function') {
      this.swiper.slideNext();
    }
  }

  onDelete(attachment: Attachment | null) {
    console.log(`${this.constructor.name}: onDelete()`); // eslint-disable-line no-console

    if (attachment) {
      this.$emit('delete', attachment);
    }
  }

  onSelect(attachment: Attachment | null) {
    console.log(`${this.constructor.name}: onSelect()`); // eslint-disable-line no-console

    if (attachment) this.$emit('select', attachment, true);
  }

  onUnselect(attachment: Attachment | null) {
    console.log(`${this.constructor.name}: onUnselect()`); // eslint-disable-line no-console

    if (attachment) this.$emit('select', attachment, false);
  }

  onDownload(attachment: Attachment | null) {
    console.log(`${this.constructor.name}: onDownload()`); // eslint-disable-line no-console

    if (attachment) {
      this.$emit('download', attachment);
    }
  }

  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;
  }
}
